export default function getCheapestRoomData(roomsData: RoomDataType[]) {
  return {
    roomPrice: roomsData[0]?.rpl[0]?.pd?.spr,
    roomPriceAfterLogin: roomsData[0]?.rpl[0]?.pd?.dspr,
    emiData: {
      emi: roomsData[0]?.rpl[0]?.pd?.emi,
      emiRates: roomsData[0]?.rpl[0]?.pd?.emid,
    },
    tax: roomsData[0]?.rpl[0]?.pd?.tnc,
  };
}
